import { message } from 'antd';
import axios from 'axios';

// Créer une instance axios de base
const axiosInstance = axios.create({
  baseURL: `${import.meta.env.VITE_PROMETHEE_BACK_BASE_URL}/api/`,
});

// Fonction pour configurer l'intercepteur avec le token
export const configureAxiosWithToken = (getToken) => {
  // Supprimer l'ancien intercepteur s'il existe
  axiosInstance.interceptors.request.clear();

  // Ajouter le nouvel intercepteur avec le token dynamique
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
};

// Fonction pour réinitialiser la configuration (pour la déconnexion)
export const resetAxiosConfig = () => {
  axiosInstance.interceptors.request.clear();
  axiosInstance.interceptors.request.use(
    (config) => config,
    (error) => Promise.reject(error)
  );
};

// Intercepteur de réponse : sur un 401 (token absent/expiré côté API),
// on déclenche `onAuthError` pour relancer le flux d'authentification.
let authErrorInFlight = false;
let responseInterceptorId = null;

export const configureAxiosAuthErrorHandler = (onAuthError) => {
  if (responseInterceptorId !== null) {
    axiosInstance.interceptors.response.eject(responseInterceptorId);
    responseInterceptorId = null;
  }
  responseInterceptorId = axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status;
      const method = (error.config?.method || 'get').toLowerCase();

      if (status === 401 && !authErrorInFlight) {
        // Token absent/expiré → relancer l'authentification.
        authErrorInFlight = true;
        onAuthError?.(error);
      } else if (status === 403 && method !== 'get') {
        // Refus d'action (droits insuffisants) sur une écriture : feedback clair
        message.error(
          "Vous n'avez pas les droits nécessaires pour effectuer cette action."
        );
      }
      return Promise.reject(error);
    }
  );
};

export default axiosInstance;
